<template>
  <div class="km__module_feedback">
    <div class="message">{{ message }}</div>
  </div>
</template>

<script lang="ts" setup>
import {ref} from "vue";
import {MessageToDisplayContainer} from "@km/components/popups/MessageToDisplayContainer";
const message = ref("");
MessageToDisplayContainer.init(message);


</script>

<style scoped lang="scss">
@use "../../scss/settings/config" as config;

.km__module_feedback {
  font-size: 11px;
  line-height: 1.45em;
  width: 180px;
  height: auto;
  position: absolute;
  bottom: 180px;
  left: 10px;
  padding: 20px;
  background: rgb(89, 204, 170);
  box-shadow: 1px 1px 8px config.$color-black;
  opacity: 0;
  z-index: -1;
}
</style>
